import React, { useEffect, useState } from 'react'
import Drawer from 'components/Drawer'
import Input from 'components/Form/Input'
import { Form, FormItem } from 'components/UIComponents/FormStyles'
import {
  FooterFlex,
  StyledSelect,
} from 'modules/Settings/Components/AddtionalInfo/style'
import Button from 'components/Button'
import SuccessMessage from 'utils/SuccessMessage'

const AddMediaLinksDrawer = ({
  addMediaDrawer,
  setAddMediaDrawer,
  socialMediaList,
  setSocialMediaList,
  onChangeFormFields,
  mediaOptions,
}) => {
  const [mediaLinksForm] = Form.useForm()
  const [mediaList, setMediaList] = useState([])

  useEffect(() => {
    setMediaList(
      mediaOptions?.filter(
        item =>
          !socialMediaList?.map(data => data?.media)?.includes(item?.value)
      )
    )
  }, [])
  const onSubmitFormData = formValues => {
    setSocialMediaList(prev => [...prev, formValues])
    onChangeFormFields()
    clearAll()
    SuccessMessage('Link added')
  }
  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'addLinksForm'}
        form={mediaLinksForm}
        layout="vertical"
        onFinish={onSubmitFormData}
      >
        <FormItem
          name="media"
          rules={[
            {
              required: true,
              message: 'Please enter media name.',
            },
          ]}
        >
          <StyledSelect
            label={'Media Name *'}
            placeholder="Enter Media Name"
            width="100%"
            options={mediaList}
            nameParam="name"
            valueParam="value"
          />
        </FormItem>
        <Input
          width="100%"
          label={'Media Link *'}
          placeholder="Eg: https://facebook.com"
          name="link"
          type="url"
          rules={[
            {
              required: true,
              message: 'Please enter media link.',
            },

            () => ({
              validator(_, value) {
                if (socialMediaList?.map(item => item?.link)?.includes(value)) {
                  return Promise.reject(new Error(`Link already added`))
                }
                return Promise.resolve()
              },
            }),
          ]}
        />
      </Form>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary onClick={clearAll} text="Cancel" height="38px" />
        <Button.Primary
          text={'Add'}
          height="38px"
          form={'addLinksForm'}
          htmlType="submit"
        />
      </FooterFlex>
    )
  }

  const clearAll = () => {
    setAddMediaDrawer(false)
    mediaLinksForm.resetFields()
  }
  return (
    <Drawer
      width="40%"
      title={'Add More Link'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={clearAll}
      visible={addMediaDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default AddMediaLinksDrawer
